(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["accordion"]) return;
  try {
    

const getElementHeight = (element) => {
  let elementHeight = element.offsetHeight
  elementHeight += parseInt(window.getComputedStyle(element).getPropertyValue('margin-top'));
  elementHeight += parseInt(window.getComputedStyle(element).getPropertyValue('margin-bottom'));
  return elementHeight;
}

class Accordion extends HTMLElement {
  constructor(accordionData, quizState , reasonState) {
    super(accordionData);
    this._accordionData = accordionData;
    this._quizGlobalState = quizState;
    this._reason = reasonState;
  }

  closeRecommendation() {
    const resultWrappers = Array.from(document.getElementsByClassName("result-wrapper"));
    const resultWrapper = resultWrappers[resultWrappers.length - 1];
    const accordionWrapperElement = document.getElementsByClassName("accordion-container")[0];
    const planMessage = document.getElementById("SelectPlanMessage");
    const planMessageMobile = document.getElementsByClassName("bottom-recommendation-wrapper-holder")[0];
    const quizElements = Array.from(document.getElementsByClassName("quiz"));
    const quizElement = quizElements[quizElements.length - 1];

    const configuratorPage = document.getElementById("configurator-page");

    configuratorPage?.classList.remove("quiz--result-backdrop");

    planMessage?.classList.remove("message-fade-out");
    planMessageMobile?.classList.remove("bottom-recommendation-wrapper-holder--hidden");

    accordionWrapperElement.scrollTo({
      top: resultWrapper.offsetTop - accordionWrapperElement.clientHeight,
      left: 0,
      behavior: "smooth"
    })
    quizElement.classList.remove("quiz-adjust-height");
  
    accordionWrapperElement.style.overflowY = 'auto';
    setTimeout(() => {
      resultWrapper.innerHTML = "";
    }, 800);
  }
  
  updateEmailField() {
    const inputWrappers = Array.from(document.querySelectorAll('.input-wrapper'));
    inputWrappers.forEach((inputWrapper) => {
      let inputValue = '';
      const input = inputWrapper.querySelector('.input');
      const button = inputWrapper.querySelector('.input-arrow');
      const helperTextElement = inputWrapper.querySelector('.input-helper');
      const emailRegex = /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/;
      const CLEAR_INPUT_TIMEOUT = 1000;
  
      input.addEventListener('input', (event) => {
        inputValue = event.target.value;
        helperTextElement.innerHTML = '';
      })
      
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const isEmail = emailRegex.test(inputValue);
        helperTextElement.innerHTML = isEmail ? 'Thanks for joining!' : 'Please enter a valid email';
        if (isEmail) {
          // TODO: this is only to show UI. Remove when integrating with e-mail system.
          setTimeout(() => {
            input.value = '';
          }, CLEAR_INPUT_TIMEOUT);
        }
      })
    });
  }

  returnFinalValue(numberValue) {
    let finalValue = '';
    
    if(numberValue === 0) {
      const lowestPlan = QUIZ_DATA.quizRules.find(element => {
        return element.min === '0'
      });      
      return lowestPlan.ruleName
    }
    
    QUIZ_DATA.quizRules.forEach(rule => {
      const intMax = parseInt(rule.max)
      const intMin = parseInt(rule.min);

      if((numberValue >= intMin) && (numberValue <= intMax)) {
        finalValue = rule.ruleName
      }
    });

    // If above values, choose rule with highest max value;
    if (finalValue == '') {
      let testValue = 0;
      let highestMaxValueRule = '';
      
      QUIZ_DATA.quizRules.forEach(rule => {
        if (parseInt(rule.max) > testValue) {
          testValue = parseInt(rule.max)
        } 
      })

      QUIZ_DATA.quizRules.forEach(rule => {
        if (testValue <= parseInt(rule.max)) {
          highestMaxValueRule = rule.ruleName;
        }
      })
      return highestMaxValueRule;
    }

    
    return finalValue;
  }

  initiateGlobalState() {
    const tempGlobalState = [];
    const accordionData = this._accordionData;
  
    accordionData.accordionData.forEach(accordionItem => {
      accordionItem.sectionQuestions.forEach(question => {
        tempGlobalState.push({
          points: 0,
          question: question.questionTitle,
          buttonTitle: ''
        })
      });
    });    
    
    
    this._quizGlobalState = tempGlobalState;
  };

  handleQuizStateUpdate(callback, buttonPoints, buttonName, questionTitle, isMultiselect) {
    const dataArray = [];
    const stateCopy = this._quizGlobalState;
    
    stateCopy.forEach((element,index) => {
      
      let buttonTitles = element.buttonTitle;

      if(element.question === questionTitle){
        if (isMultiselect) {

          if(!element.buttonTitle) {
            dataArray.push({...element, points: element.points + buttonPoints, buttonTitle: [buttonName]});
          } else {
            const titleExistsInbuttonTitles = element.buttonTitle.some(title => title == buttonName);
            
            if(titleExistsInbuttonTitles){
              const copyOfButtonTitle = element.buttonTitle;
              const titleIndex = copyOfButtonTitle.indexOf(buttonName);

              if (titleIndex > -1) {
                copyOfButtonTitle.splice(titleIndex, 1);
              }
              
              dataArray.push({...element, points: element.points - buttonPoints, buttonTitle: copyOfButtonTitle});
            }else {
              dataArray.push({...element, points: element.points + buttonPoints, buttonTitle: [...element.buttonTitle, buttonName]});
            }
          }
        } else {
          
          //If not multiselect
          dataArray.push({...element, points:buttonPoints, buttonTitle: buttonName});
        }
      } else {
        //Pass other elements
        dataArray.push(element);
      }
    });

    this._quizGlobalState = dataArray;

    let finalNumberValue = 0;
    this._quizGlobalState.forEach(element => {
      finalNumberValue = finalNumberValue + element.points;
    });
    
    const final = this.returnFinalValue(finalNumberValue);
    
    QUIZ_DATA.quizRules.forEach(element => {
      if (element.ruleName === final) {
        this._reason = element.reason;
      }
    });
    
    //Need to return computed data from accordion class to configurator.js,
    //so the next time we enter quiz, we have saved values.
    //This callback is basicaly accordionCallback function in configurator.js.
    callback(final, this._quizGlobalState, this._reason);
    
    //Toggle disable state on "Done" button
    const doneButton = document.getElementById("DoneButton");
    
    doneButton.disabled = recommendedChoice === "" ? true : false;
  };

  renderArrowIcon() {
    const iconSvg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    const iconPath = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );

    iconSvg.setAttribute("fill", "none");
    iconSvg.setAttribute("viewBox", "0 0 12 8");
    iconSvg.classList.add("accordion-arrow");

    iconPath.setAttribute(
      "d",
      "M12 0.666748L6 7.33341L0 0.666748L12 0.666748Z"
    );
    iconPath.setAttribute("fill-rule", "evenodd");
    iconPath.setAttribute("clip-rule", "evenodd");
    iconPath.setAttribute("fill", "black");

    iconSvg.appendChild(iconPath);

    return iconSvg;
  }

  renderChevronUpSvg() {
    const iconSvg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    const iconPath = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );

    iconSvg.setAttribute("fill", "none");
    iconSvg.setAttribute("viewBox", "0 0 22 12");
    iconSvg.classList.add("chevron-up");

    iconPath.setAttribute(
      "d",
      "M1 11L11 1L21 11"
    );
    iconPath.setAttribute("stroke-width", "2");
    iconPath.setAttribute("stroke-linecap", "round");
    iconPath.setAttribute("stroke", "black");
    iconPath.setAttribute("stroke-linejoin", "round");

    iconSvg.appendChild(iconPath);

    return iconSvg;
  }
  
  renderDropdownQuestion(question,callback) {
    //Get previous answer if chosen.
    let previouslyChosenOption;
    if (this._quizGlobalState !== undefined) {
      this._quizGlobalState.forEach(element => {
        if (element.question === question.questionTitle) {
          previouslyChosenOption = element.buttonTitle;
        }
      });
    }
      
    const dropDownSelectWrapper = document.createElement("div");
    dropDownSelectWrapper.classList.add("dropDownSelectWrapper");
    const dropdownSelect = document.createElement("select");
    dropdownSelect.classList.add("typography", "body-large-emphasize", "choice-button-wrapper", "dropdownSelect");

    const helperText = document.createElement("p");
    helperText.classList.add("typography", "caption", "dropdownHelperText");
    
    dropdownSelect.onchange = (e) => {
    dropdownSelect.classList.add('dropdownSelect--withValue');
      dropdownSelect.value =
        dropdownSelect.options[dropdownSelect.selectedIndex].text;

      question.questionOptions.forEach((element) => {
        if (element.title === dropdownSelect.value) {
          helperText.innerHTML = element.helperText || "";
         //Write points to the quizGlobalState
          this.handleQuizStateUpdate(callback,parseInt(element.points),element.title,question.questionTitle, false);
        }
      });
    };

    const defaultOption = document.createElement("option");
    defaultOption.classList.add("typography", "label", "selectPlaceholder");
    defaultOption.innerHTML = "Select state...";
    defaultOption.selected = previouslyChosenOption ? false :true;
    defaultOption.disabled = true;

    dropdownSelect.appendChild(defaultOption);

    question.questionOptions.forEach((option) => {
      const optionElement = document.createElement("option");
      optionElement.classList.add("dropdownSelect-option");
      optionElement.innerHTML = option.title;
      optionElement.dataset.value = option.points;
      if(option.title === previouslyChosenOption) {
        optionElement.selected = true;
      }
      
      dropdownSelect.appendChild(optionElement);
    });

    dropDownSelectWrapper.appendChild(dropdownSelect);
    dropDownSelectWrapper.appendChild(helperText);

    return dropDownSelectWrapper;
  }

  renderSelectQuestion(question, isMultiselect, accordionCallback) {
    const selectButtonsWrapper = document.createElement("div");
    selectButtonsWrapper.classList.add("selectButtonsWrapper");

    question.questionOptions.forEach((option) => {
      let previouslyChosenOption;
      if (this._quizGlobalState !== undefined) {
        this._quizGlobalState.forEach(element => {
          if (element.question === question.questionTitle) {
            previouslyChosenOption = element.buttonTitle;;
          } 
        });
      };

      const selectButtonElement = document.createElement("button");
      selectButtonElement.classList.add(
        "selectButtonElement",
        "choice-button-wrapper"
      );

      if (Array.isArray(previouslyChosenOption)) {
        if (previouslyChosenOption.includes(option.title)) {
          selectButtonElement.classList.add("selectedSelectButtonElement","choice-button__icon-check");
        }
      } else if(previouslyChosenOption === option.title) {
        selectButtonElement.classList.add("selectedSelectButtonElement");
      }
      
      selectButtonElement.setAttribute("value", option.points);
     
      const selectButtonInfoWrapper = document.createElement("div");
      selectButtonInfoWrapper.classList.add("choice-button-info-wrapper");

      const selectButtonTitleElement = document.createElement("p");
      selectButtonTitleElement.classList.add(
        "typography",
        "label",
        "choice-button__title"
      );
      selectButtonTitleElement.innerHTML = option.title;

      if (option.icon && option.icon.includes("svg")) {
        const selectButtonIcon = document.createElement("div");
        selectButtonIcon.classList.add("choice-button__icon-wrapper");
        selectButtonIcon.innerHTML = option.icon;
        selectButtonElement.appendChild(selectButtonIcon);
      }

      selectButtonElement.addEventListener("click",(e) => {
        const buttonParentElement = e.currentTarget.parentElement;
        const arrayOfButtons = Array.from(
          buttonParentElement.getElementsByClassName("selectButtonElement")
        );
        
        if (!isMultiselect) {
          this.handleQuizStateUpdate(
            accordionCallback, 
            parseInt(e.currentTarget.value),
            e.currentTarget.textContent,
            question.questionTitle,
            false
          );

          arrayOfButtons.forEach((button) => {
            button.classList.remove("selectedSelectButtonElement");
          });
          
          e.currentTarget.classList.add("selectedSelectButtonElement");
        } else {
          this.handleQuizStateUpdate(
            accordionCallback, 
            parseInt(e.currentTarget.value),
            e.currentTarget.textContent,
            question.questionTitle,
            true
          );
          
          if (e.currentTarget.classList.contains("choice-button__icon-check")) {
            e.currentTarget.classList.remove("choice-button__icon-check");
            e.currentTarget.classList.remove("selectedSelectButtonElement");
            e.currentTarget.removeAttribute("data-selected");
          } else {
            e.currentTarget.classList.add("choice-button__icon-check");
            e.currentTarget.classList.add("selectedSelectButtonElement");
            e.currentTarget.setAttribute("data-selected", "");
          }
        }
      });

      selectButtonInfoWrapper.appendChild(selectButtonTitleElement);
      selectButtonElement.appendChild(selectButtonInfoWrapper);
      selectButtonsWrapper.appendChild(selectButtonElement);
    });
    return selectButtonsWrapper;
  }

  renderAccordion(parentElement, titleElements, contentElements, shouldCloseSiblings = true) {
    // titleElements and contentElements must match in length
    const accordionWrapperElement = document.createElement("div");
    accordionWrapperElement.classList.add("accordionWrapperElement");

    titleElements.forEach((element, index) => {
      const titleElement = titleElements[index];
      const contentElement = contentElements[index];

      const accordionSection = document.createElement("div");
      accordionSection.tabIndex = 0;
      accordionSection.classList.add("accordionSection");

      const accordionSectionTitleWrapper = document.createElement("div");
      
      accordionSectionTitleWrapper.classList.add(
        "accordionSectionTitleWrapper",
        "accordionSectionTitleWrapper-space-between",
      );
      
      const accordionArrow = this.renderArrowIcon();

      accordionSectionTitleWrapper.appendChild(titleElement);
      accordionSectionTitleWrapper.appendChild(accordionArrow);

      //Mount all accordion hidden content inside this div;
      const sectionContent = document.createElement("div");
      sectionContent.classList.add("sectionContent");
      sectionContent.dataset.open = "false";

      sectionContent.appendChild(contentElement);

      accordionSection.appendChild(accordionSectionTitleWrapper);
      accordionSection.appendChild(sectionContent);
      accordionWrapperElement.appendChild(accordionSection);

      accordionSection.addEventListener('keypress',(event)=> {
        if(event.which == 32) {
          event.preventDefault();
          accordionSection.click();
        }
      });
    });

    parentElement.appendChild(accordionWrapperElement);
    
    setTimeout(() => {
      const arrayOfAllAccordionSections = Array.from(parentElement.getElementsByClassName("accordionSection"));

      arrayOfAllAccordionSections.forEach(element => {
        const titleElement = element.getElementsByClassName("accordionSectionTitleWrapper")[0];
        const titleElementHeight = getElementHeight(titleElement); 
        
        const contentElement = element.getElementsByClassName("sectionContent")[0];
        const contentElementHeight = getElementHeight(contentElement);
        
        element.dataset.open = "false";
        element.dataset.openedHeight = contentElementHeight;
        element.dataset.closedHeight = titleElementHeight;
        element.style.height = `${titleElementHeight}px`;

        element.addEventListener('click', (event) => {
          if(event.target !== event.currentTarget) return
            const currentElement = event.currentTarget;
            const foundContentElement = event.target.getElementsByClassName("sectionContent")[0];
            const allSectionElements = Array.from(document.getElementsByClassName("sectionContent"));
            const isOpen = currentElement.dataset.open === "true";
            const elementOpenedHeight = parseInt(element.dataset.openedHeight);
            const elementClosedHeight = parseInt(element.dataset.closedHeight);
            const totalHeightWhenOpen = elementClosedHeight + elementOpenedHeight;          

            if (shouldCloseSiblings) {
              arrayOfAllAccordionSections.forEach((element) => {
                element.dataset.open = "false";
                element.getElementsByClassName("sectionContent")[0].dataset.open = "false";
              });
              currentElement.dataset.open = isOpen ? "false" : "true";
              foundContentElement.dataset.open = "true";
              
              arrayOfAllAccordionSections.forEach((element) => {
                if (element.dataset.open === "false") {
                  element.style.height = `${element.dataset.closedHeight}px`;
                }
              });
            } else {
              currentElement.dataset.open = isOpen ? "false" : "true";
            }
            currentElement.style.height = isOpen ? `${currentElement.dataset.closedHeight}px` : `${totalHeightWhenOpen}px`;
        })  
      });
    }, 100);
  }
  //Leaving selectButtonCallback and subscriptionCallback for future implementations.
  renderResults(selectButtonCallback, subscriptionCallback) {
    let finalNumberValue = 0;
    this._quizGlobalState.forEach(element => {
      finalNumberValue = finalNumberValue + element.points;
    });
    
    const recommendedPlan = this.returnFinalValue(finalNumberValue);

    //One container
    const resultContainer = document.createElement('div');
    resultContainer.classList.add("result-container");

    //Three divisions. (heading, content, subscription)
    const heading = document.createElement('div');
    heading.classList.add("result-heading");
    
    const content = document.createElement('div');
    content.classList.add("result-content");

    const subscription = document.createElement('div');
    subscription.classList.add("result-subscription");
    
    const eyebrow = document.createElement('p');
    eyebrow.classList.add(
      "typography",
      "body-large-emphasize",
      "result-eyebrow"
    );
    eyebrow.innerHTML = "Based on your answers:"
    
    const title = document.createElement('p');
    title.classList.add(
      "typography",
      "headline-m",
      "result-title"
    );
    
    title.innerHTML = `Replen every ${recommendedPlan ? recommendedPlan : "6 months"}` // should be changed by quiz points
    
    //Button creation
    const selectButton = document.createElement('button');
    selectButton.classList.add("result-select-button",`message-${planStrength ? planStrength : "low"}-months`); // should be changed by quiz points (color)
    const buttonText = document.createElement('p');
    buttonText.classList.add("typography","body-large-emphasize");
    buttonText.innerHTML = "Select";
    selectButton.appendChild(buttonText);

    selectButton.addEventListener("click", (e) => {
      selectButtonCallback && selectButtonCallback();
      const select = document.getElementsByClassName("selectPlanMessageButton")[0];
      select.click();
    });

    const paragraph = document.createElement('p');
    paragraph.classList.add("typograhy", "body", "result-list-item");
    paragraph.innerHTML = this._reason || "";

    const subscriptionTitle = document.createElement('p');
    subscriptionTitle.classList.add(
      "typography",
      "body-large-emphasize",
      "result-subscription-title"
    );
    subscriptionTitle.innerHTML = "Enter your email to learn more";
    
    const klaviyoWrapper = document.createElement('div');
    klaviyoWrapper.classList.add('klaviyo-embed');
    const klaviyoForm = document.createElement('div');
    klaviyoForm.classList.add(`klaviyo-form-${klaviyoFormId}`);

    klaviyoWrapper.appendChild(klaviyoForm);
    
    const backButton = document.createElement('button');
    backButton.classList.add("result-back-button");
    backButton.appendChild(this.renderChevronUpSvg());
    backButton.addEventListener("click", (e) => {
      this.closeRecommendation();
    });

    // Append heading children
    heading.appendChild(eyebrow);
    heading.appendChild(title);
    heading.appendChild(selectButton);

    // Append paragraph 
    content.appendChild(paragraph);
    
    // Append subscription children
    subscription.appendChild(subscriptionTitle);
    subscription.appendChild(klaviyoWrapper);

    
    // Append three divisions and button to container element
    resultContainer.appendChild(heading);
    resultContainer.appendChild(content);
    resultContainer.appendChild(subscription);
    resultContainer.appendChild(backButton);
    
    return resultContainer;
  }
  
  renderSection(parentElement, accordionCallback, shouldCloseSiblings = true) {
    if (this._quizGlobalState === undefined) {
      this.initiateGlobalState();
    }
    
    const accordionWrapperElement = document.getElementsByClassName(
      "accordion-container"
      )[0];
    accordionWrapperElement.style.overflowY = 'auto';
    accordionWrapperElement.textContent = "";
    const accordionTitle = document.createElement("h1");
    accordionTitle.classList.add(
      "typography",
      "headline-m",
      "accordionHeadline"
    );
    accordionTitle.innerHTML = this._accordionData.accordionTitle;
    accordionWrapperElement.appendChild(accordionTitle);
    
    this._accordionData.accordionData.map((dataItem, index) => {
      const accordionSection = document.createElement("div");
      accordionSection.classList.add("accordionSection");
      accordionSection.dataset.open = "false";

      const accordionSectionTitleWrapper = document.createElement("div");
      accordionSectionTitleWrapper.classList.add(
        "accordionSectionTitleWrapper",
        "accordionSectionTitleWrapper-configurator",
      );
      const accordionSectionTitleIcon = document.createElement("div");
      accordionSectionTitleIcon.classList.add("accordionSectionTitleIcon");
      accordionSectionTitleIcon.innerHTML = dataItem.icon;

      const accordionSectionTitle = document.createElement("h2");
      accordionSectionTitle.classList.add(
        "typography",
        "headline-s",
        "accordionSectionTitle"
      );
      accordionSectionTitle.innerHTML = dataItem.title;

      const accordionArrow = this.renderArrowIcon();

      accordionSectionTitleWrapper.appendChild(accordionSectionTitleIcon);
      accordionSectionTitleWrapper.appendChild(accordionSectionTitle);
      accordionSectionTitleWrapper.appendChild(accordionArrow);

      //Mount all accordion hidden content inside this div;
      const sectionContent = document.createElement("div");
      sectionContent.classList.add("sectionContent", "sectionContent-configurator");
      sectionContent.dataset.open = "false";

      const accordionSectionDescription = document.createElement("p");
      accordionSectionDescription.classList.add(
        "typography",
        "body",
        "accordionSectionDescription"
      );
      accordionSectionDescription.innerHTML = dataItem.description;

      sectionContent.appendChild(accordionSectionDescription);

      dataItem.sectionQuestions.map((question, index) => {
        const questionTitle = document.createElement("p");
        questionTitle.classList.add(
          "typography",
          "body-large-emphasize",
          "questionTitle"
        );
        questionTitle.innerHTML = question.questionTitle;
        sectionContent.appendChild(questionTitle);

        const questionDescription = document.createElement("p");
        questionDescription.classList.add("questionDescription");
        sectionContent.appendChild(questionDescription);

        switch (question.questionType) {
          case "dropdown":
            sectionContent.appendChild(this.renderDropdownQuestion(question, accordionCallback));
            break;
          case "select":
            sectionContent.appendChild(
              this.renderSelectQuestion(question, false, accordionCallback)
            );
            break;
          case "multi-select":
            sectionContent.appendChild(
              this.renderSelectQuestion(question, true, accordionCallback)
            );
            break;
          default:
            break;
        }
      });

      accordionSection.appendChild(accordionSectionTitleWrapper);
      accordionSection.appendChild(sectionContent);

      accordionWrapperElement.appendChild(accordionSection);

      const nextButton = document.createElement("button");
      nextButton.setAttribute("aria-label","Go to next section item");
      const doneButton = document.createElement("button");
      doneButton.setAttribute("aria-label","Quiz done button");
      nextButton.classList.add(
        "typography",
        "body-large-emphasize",
        "nextButton"
      );

      doneButton.classList.add(
        "typography",
        "body-large-emphasize",
        "nextButton"
      );
      doneButton.id = "DoneButton"

      nextButton.dataset.order = `${index}`;
      doneButton.dataset.order = `${index + 1}`;
      nextButton.innerHTML = "Next";
      doneButton.innerHTML = "Done";
      
      //Initiate done button with disabled state
      let isDoneButtonDisabled = true;

      if(this._quizGlobalState) {
        this._quizGlobalState.forEach(element => {
          if (element.points !==0) {
            isDoneButtonDisabled = false;
          }
        }); 
      }
      
      doneButton.disabled = isDoneButtonDisabled;

      nextButton.addEventListener("click", (e) => {
        const buttonElement = e.currentTarget;
        const parentElement = buttonElement.parentElement;
        const buttonOrder = parseInt(buttonElement.dataset.order);
        const allSectionElements = Array.from(
          document.getElementsByClassName("accordionSection")
        );
        if (this._accordionData.accordionData.length - 1 > buttonOrder) {
          allSectionElements[buttonOrder + 1].click();
        }
      });

      const resultWrapper = document.createElement('div');
      accordionWrapperElement.appendChild(resultWrapper);
      resultWrapper.classList.add("result-wrapper");

      doneButton.addEventListener("click", (e) => {
        const planMessage = document.getElementById("SelectPlanMessage");
        const planMessageMobile = document.getElementsByClassName("bottom-recommendation-wrapper-holder")[0];
        const quizElements = Array.from(document.getElementsByClassName("quiz"));
        const quizElement = quizElements[quizElements.length - 1];

        const configuratorPage = document.getElementById("configurator-page");
        
       //Show results
        resultWrapper.innerHTML = '';
        
        resultWrapper.appendChild(this.renderResults());
        const offset = resultWrapper.offsetTop;
        this.updateEmailField();

        setTimeout(() => {
          accordionWrapperElement.scrollTo({
            top: offset,
            left: 0,
            behavior: "smooth"
          })
          quizElement.classList.add("quiz-adjust-height");
          resultWrapper.style.opacity = 1;
          planMessage.classList.add("message-fade-out");
        }, 500);

        setTimeout(() => {
          accordionWrapperElement.style.overflowY = 'hidden';
          planMessageMobile?.classList.add("bottom-recommendation-wrapper-holder--hidden");
          configuratorPage?.classList.add("quiz--result-backdrop");
        }, 1200);
      })
      
      if (this._accordionData.accordionData.length - 1 !== index) {
        sectionContent.appendChild(nextButton);
      } else {
        sectionContent.appendChild(doneButton);
      }
    });

    parentElement.appendChild(accordionWrapperElement);
    

    setTimeout(() => {
      const arrayOfAllAccordionSections = Array.from(parentElement.getElementsByClassName("accordionSection"));

      arrayOfAllAccordionSections.forEach((element,index) => {
        const titleElement = element.getElementsByClassName("accordionSectionTitleWrapper")[0];
        
        const titleElementHeight = getElementHeight(titleElement); 
        
        const contentElement = element.getElementsByClassName("sectionContent")[0];
        const contentElementHeight = getElementHeight(contentElement);
        
        element.dataset.openedHeight = contentElementHeight;
        element.dataset.closedHeight = titleElementHeight;
        element.style.height = `${titleElementHeight}px`;

        if (!index) {
          element.style.height = `${titleElementHeight + contentElementHeight}px`;
          element.dataset.open = "true";
        }
        
        element.addEventListener('click', (event) => {
            if (event.target !== event.currentTarget) return
            const currentElement = event.currentTarget;
            const foundContentElement = event.target.getElementsByClassName("sectionContent")[0];
            const allSectionElements = Array.from(document.getElementsByClassName("sectionContent"));
            const isOpen = foundContentElement.dataset.open === "true";
            const elementOpenedHeight = parseInt(element.dataset.openedHeight);
            const elementClosedHeight = parseInt(element.dataset.closedHeight);
            const totalHeightWhenOpen = elementClosedHeight + elementOpenedHeight;
            
            arrayOfAllAccordionSections.forEach((element) => {
              if (element !== currentElement) {
                element.style.height = `${element.dataset.closedHeight}px`
                element.dataset.open = "false";
              }
            });
              currentElement.style.height = `${totalHeightWhenOpen}px`;
              currentElement.dataset.open = "true";
        })  
      });
    }, 100);
  };
}

customElements.define("accordion-component", Accordion);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-footer"] && !window.DesignMode) return;
  try {
    

const element = document.querySelector('.design-footer-video-wrapper');
const video = document.querySelector('.design-footer-video');

const scrobbleVideo = () => {
  const duration = video.duration;

  // Get the relevant measurements and positions
  const viewportHeight = window.innerHeight;
  const scrollTop = window.scrollY;
  const elementOffsetTop = element.offsetTop;
  const elementHeight = element.offsetHeight;

  // Calculate percentage of the element that's been seen
  const distance = scrollTop + viewportHeight - elementOffsetTop;
  const percentage = Math.round(
    distance / ((viewportHeight + elementHeight) / 100)
  );

  if (!isNaN(video.duration) && percentage > 0 && percentage <= 100) {
    requestAnimationFrame(() => {
      video.currentTime = (duration / 100) * percentage;
    });
  }
};

video.onloadedmetadata = scrobbleVideo();

// Without "autoplay" attribute video will not show up in iPhone.
// We just pause it here once it starts playing.
video.ontimeupdate = () => {
  if (!video.paused) {
    video.pause();
  }
}

window.addEventListener("scroll", scrobbleVideo);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-module"] && !window.DesignMode) return;
  try {
    

const allHotspots = Array.from(document.getElementsByClassName('design-module-hotspot'));
const allTooltips = Array.from(document.getElementsByClassName('design-module-hotspot-tooltip'));
const explainerSheet = document.getElementById("design-module-explainerSheet");
const explainerSheetInner = document.querySelector(".design-module-explainerSheet-inner");
const eyeButton = explainerSheet.getElementsByTagName("svg")[0];
const htmlElement = document.documentElement;
let explainerSheetOpen = false;

const toggleMobileExplainerSheet = () => {
  explainerSheet.classList.toggle("explainerSheet-mobile-open");

  if (explainerSheetOpen) {
    explainerSheetOpen = false;
    allHotspots.forEach((hotspot) => {
      hotspot.classList.remove('hotspot--paused');
    });
    if ('bodyScrollLock' in window) {
      bodyScrollLock.enableBodyScroll(explainerSheet);
    }
  } else {
    explainerSheetOpen = true;
    allHotspots.forEach((hotspot) => {
      hotspot.classList.add('hotspot--paused');
    });
    if ('bodyScrollLock' in window) {
      bodyScrollLock.disableBodyScroll(explainerSheet);
    }
  }
}

eyeButton.addEventListener("click", () => {
  toggleMobileExplainerSheet();

  const previouslyVisibleImage = document.querySelector('.design-module-tooltipImage--visible');
  if (previouslyVisibleImage) {
    previouslyVisibleImage.classList.remove('design-module-tooltipImage--visible');
  }
});

const toggleTooltip = (hotspotIndex) => {
  allTooltips.forEach((tooltip, tooltipIndex) => {
    if (hotspotIndex === tooltipIndex) {
      const parent = tooltip.parentElement;
      const img = parent.querySelector('.design-module-tooltipImage');

      if (img) {
        img.classList.add('design-module-tooltipImage--visible');
      }
      // Empty explainerSheet container
      explainerSheetInner.childNodes.forEach(element => {
        if(element.tagName === "DIV") {
          element.remove();
        }
      });
      //Open ExplainerSheet
      toggleMobileExplainerSheet();
      //Clone and append tooltip
      const clone = tooltip.cloneNode(true);
      clone.style.left = "unset";
      clone.style.top = "unset";    
      explainerSheetInner.appendChild(clone);
    }
  });
}

allHotspots.forEach((hotspot, index) => {
  hotspot.addEventListener("click", (e) => {
    if(window.innerWidth < 900) {
      toggleTooltip(index);
    }
  })
  const openEvents = ['mouseenter','focus'];
  const closeEvents = ['mouseleave','blur'];
  
  openEvents.forEach(eventType => {
    hotspot.addEventListener(eventType, ()=> {
      hotspot.classList.add("design-module-hotspot--hover");
    })
  });
  closeEvents.forEach(eventType => {
    hotspot.addEventListener(eventType, ()=> {
      hotspot.classList.remove("design-module-hotspot--hover");
    });
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-go-gift-card"] && !window.DesignMode) return;
  try {
    
  const heroSwiper = new Swiper('.swiper-hero', {
    loop: imagesCount > 1,
  });

  const allPaginationElements = Array.from(document.getElementsByClassName('hero-carousel-custom-pagination-item'));

  let isFirstLoad = false;
  if (!isFirstLoad) {
    if (allPaginationElements && allPaginationElements[0]) {
      allPaginationElements[0].dataset.active = true;
    }
    isFirstLoad = true;
  }

  heroSwiper.on('transitionEnd', () => {
    heroSwiper.realIndex;
    allPaginationElements.forEach((paginationElement, index) => {
      if (index === heroSwiper.realIndex) {
        paginationElement.dataset.active = true;
        paginationElement.dataset.tooltip = true;
      } else {
        paginationElement.dataset.active = false;
        paginationElement.dataset.tooltip = false;
      }
    });
  });

  allPaginationElements.forEach((paginationElement, index) => {
    paginationElement.addEventListener('click', () => {
      heroSwiper.slideTo(index + 1);
      allPaginationElements.forEach((item) => {
        item.dataset.active = false;
        item.dataset.tooltip = false;
      });
      allPaginationElements[index].dataset.active = true;
      allPaginationElements[index].dataset.tooltip = true;
    });
  });

  const buyBar = document.getElementById('BuyBar');
  const buyBarMask = document.getElementsByClassName('hero-buyBar-mask')[0];
  const hero = document.getElementById('Hero');
  const buyBarDesktop = document.querySelector('.buy-bar');
  const buyBarDesktopContainer = document.querySelector('.buyBar-lg');
  const research = document.querySelector('.research');
  const headerHeight = 80; // needs to match CSS;

  document.addEventListener('scroll', () => {
    const offsetTop = buyBarMask.getBoundingClientRect().top;
    const researchRect = research && research.getBoundingClientRect();
    const isBuyBarBlack = researchRect && researchRect.top <= headerHeight && researchRect.bottom >= headerHeight;
    const screenWidth = window.innerWidth;
    const buyBarElement = screenWidth < 600 ? buyBar : buyBarDesktopContainer;

    if (buyBarElement) {
      if (isBuyBarBlack) {
        buyBarElement.classList.add('hero-buyBar--black');
      } else {
        buyBarElement.classList.remove('hero-buyBar--black');
      }
    }
    //Mobile
    if (screenWidth < 600) {
      if (offsetTop <= 0) {
        buyBar.style.position = 'fixed';
        buyBarMask.style.height = '80px';
      } else {
        buyBar.style.position = 'static';
        buyBarMask.style.height = '0';
      }
    } else {
      const scrollTop = window.scrollY;
      const heroHeight = hero.clientHeight;

      if (buyBarDesktop) {
        if (scrollTop > heroHeight) {
          buyBarDesktop.classList.add('buy-bar-visible');
        } else {
          buyBarDesktop.classList.remove('buy-bar-visible');
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !window.DesignMode) return;
  try {
    

const heroSwiper = new Swiper('.swiper-hero', {
    loop: imagesCount > 1,
});

const allPaginationElements = Array.from(document.getElementsByClassName("hero-carousel-custom-pagination-item"));

let isFirstLoad = false;
if (!isFirstLoad) {
    if (allPaginationElements && allPaginationElements[0]) {
        allPaginationElements[0].dataset.active = true;
    }
    isFirstLoad = true;
};

heroSwiper.on("transitionEnd", () => {
    heroSwiper.realIndex;
    allPaginationElements.forEach((paginationElement, index) => {
        if (index === heroSwiper.realIndex) {
            paginationElement.dataset.active = true;
            paginationElement.dataset.tooltip = true;
        } else {
            paginationElement.dataset.active = false;
            paginationElement.dataset.tooltip = false;
        }
    });
});

allPaginationElements.forEach((paginationElement, index) => {
    paginationElement.addEventListener("click",()=>{
        heroSwiper.slideTo(index + 1);
        allPaginationElements.forEach(item => {
            item.dataset.active = false;
            item.dataset.tooltip = false;
        });
        allPaginationElements[index].dataset.active = true;
        allPaginationElements[index].dataset.tooltip = true;
    })
});


const buyBar = document.getElementById("BuyBar");
const buyBarMask = document.getElementsByClassName("hero-buyBar-mask")[0];
const hero = document.getElementById("Hero");
const buyBarDesktop = document.querySelector(".buy-bar");
const buyBarDesktopContainer = document.querySelector('.buyBar-lg');
const research = document.querySelector('.research');
const headerHeight = 80; // needs to match CSS;

document.addEventListener("scroll", () => {
    const offsetTop = buyBarMask.getBoundingClientRect().top;
    const researchRect = research && research.getBoundingClientRect();
    const isBuyBarBlack = researchRect && researchRect.top <= headerHeight && researchRect.bottom >= headerHeight;
    const screenWidth = window.innerWidth;
    const buyBarElement = screenWidth < 600 ? buyBar : buyBarDesktopContainer;

    if (buyBarElement) {
        if (isBuyBarBlack) {
            buyBarElement.classList.add('hero-buyBar--black');
        } else {
            buyBarElement.classList.remove('hero-buyBar--black');
        }
    } 
    //Mobile 
    if (screenWidth < 600) {
        if (offsetTop <= 0) {
            buyBar.style.position = "fixed";
            buyBarMask.style.height = "80px";
        } else {
            buyBar.style.position = "static";
            buyBarMask.style.height = "0";
        }
    } else {
        const scrollTop = window.scrollY;
        const heroHeight = hero.clientHeight;

        if (buyBarDesktop) {
            if (scrollTop > heroHeight) {
                buyBarDesktop.classList.add("buy-bar-visible");
            } else {
                buyBarDesktop.classList.remove("buy-bar-visible");
            }        
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !window.DesignMode) return;
  try {
    
  const announcementBar = document.getElementById("shopify-section-announcement-bar");
  const homeHeroWrapper = document.querySelector(".home-hero-video-wrapper");

  if (!announcementBar && window.innerWidth < 600) {
    homeHeroWrapper.style.height = "calc(100vh - 80px)";
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-plans"] && !window.DesignMode) return;
  try {
    
const PICK_YOUR_PLAN_NUMBER_INTERVAL = 5000;
let number = 3;
let animationInterval;
let animationStatus = "ANIMATING";
const hoverHeights = [];

const MAPPED_NUMBERS_TO_INDEXES = {
  3: 0,
  6: 1,
  9: 2,
};

const MAPPED_INDEXES_TO_NUMBERS = {
  0: 3,
  1: 6,
  2: 9,
};

const svgs = Array.from(document.querySelectorAll(".home-plans-avatar-circle"));
const avatars = Array.from(document.querySelectorAll(".home-plans-avatar"));
const items = Array.from(document.querySelectorAll(".home-plans-item"));
const itemsWrapper = document.querySelector('.home-plans-items');
const numberWrapper = document.querySelector(".home-plans-number");

if (items && items[0]) {
  itemsWrapper.style.minHeight = `${items[0].clientHeight}px`;
  items.forEach((item) => item.style.position = 'absolute');
}

const animationIntervalFunction = () => {
  number = number === 9 ? 3 : number + 3;

  svgs.forEach((svg) => {
    if (svg.classList.contains("home-plans-avatar-circle--animating")) {
      svg.classList.remove("home-plans-avatar-circle--animating");
    }
    svgs[MAPPED_NUMBERS_TO_INDEXES[number]].classList.add(
      "home-plans-avatar-circle--animating"
    );
  });

  avatars.forEach((avatar) => {
    if (avatar.classList.contains("home-plans-avatar--active")) {
      avatar.classList.remove("home-plans-avatar--active");
    }
    avatars[MAPPED_NUMBERS_TO_INDEXES[number]].classList.add(
      "home-plans-avatar--active"
    );
    animatedNumber.animate(number);
  });

  items.forEach((item) => {
    if (item.classList.contains("home-plans-item--active")) {
      item.classList.remove("home-plans-item--active");
    }
    items[MAPPED_NUMBERS_TO_INDEXES[number]].classList.add(
      "home-plans-item--active"
    );
    animatedNumber.animate(number);
  });
};

desktopNumberReadyCallback = () => {
  if (window.innerWidth >= 900) {
    const numbersWrappers = Array.from(document.querySelectorAll('.home-plans-desktop-item-number'));
    numbersWrappers.forEach((numberWrapperElement, numberWrapperIndex) => {
      numberWrapperElement.appendChild(animatedNumbers[numberWrapperIndex].init(MAPPED_INDEXES_TO_NUMBERS[numberWrapperIndex]));
      animatedNumbers[numberWrapperIndex].animate(MAPPED_INDEXES_TO_NUMBERS[numberWrapperIndex]);
    });

    const allHoverElements = Array.from(document.querySelectorAll('.home-plans-desktop-item-content--hover'));

    allHoverElements.forEach((elem) => {
      hoverHeights.push(elem.offsetHeight);
    })

    const allItems = Array.from(document.querySelectorAll('.home-plans-desktop-item'));

    allItems.forEach((item, index) => {
      item.addEventListener('mouseenter', (event) => {
        const contentItem = event.target.querySelector('.home-plans-desktop-item-content');

        if (contentItem) {
          contentItem.style.transform = `translateY(-${hoverHeights[index]}px)`;
        }
      });

      item.addEventListener('mouseleave', (event) => {
        const contentItem = event.target.querySelector('.home-plans-desktop-item-content');
        if (contentItem) {
          contentItem.style.transform = 'translateY(0)';
        }
      })
    })
  }
}

const numberReadyCallback = () => {
  if (window.innerWidth < 900) {
    numberWrapper.appendChild(animatedNumber.init(number));
  animatedNumber.animate(number);

  if (svgs && svgs.length) {
    svgs[MAPPED_NUMBERS_TO_INDEXES[number]].classList.add(
      "home-plans-avatar-circle--animating"
    );
    avatars[MAPPED_NUMBERS_TO_INDEXES[number]].classList.add(
      "home-plans-avatar--active"
    );
    items[MAPPED_NUMBERS_TO_INDEXES[number]].classList.add(
      "home-plans-item--active"
    );

    animationInterval = setInterval(
      () => animationIntervalFunction(),
      PICK_YOUR_PLAN_NUMBER_INTERVAL
    );
  }

  avatars.forEach((avatar, index) =>
    avatar.addEventListener("click", function (event) {
      clearInterval(animationInterval);
      avatars.forEach((avatar) => {
        if (avatar.classList.contains("home-plans-avatar--active")) {
          avatar.classList.remove("home-plans-avatar--active");
        }
        avatars[index].classList.add("home-plans-avatar--active");
      });

      if (MAPPED_NUMBERS_TO_INDEXES[number] !== index) {
        animationStatus = "ANIMATING";
        number = MAPPED_INDEXES_TO_NUMBERS[index];
        animatedNumber.animate(number);

        items.forEach((item, itemIndex) => {
          if (item.classList.contains("home-plans-item--active")) {
            item.classList.remove("home-plans-item--active");
          }

          if (itemIndex === index) {
            item.classList.add("home-plans-item--active");
          }
        });
      } else {
        animationStatus =
          animationStatus === "ANIMATING" ? "PAUSED" : "ANIMATING";
      }

      svgs.forEach((svg) => {
        if (svg.classList.contains("home-plans-avatar-circle--animating")) {
          svg.classList.remove("home-plans-avatar-circle--animating");
        }
      });

      if (animationStatus === "ANIMATING") {
        // start interval
        svgs.forEach((svg) => {
          if (svg.classList.contains("home-plans-avatar-circle--animating")) {
            svg.classList.remove("home-plans-avatar-circle--animating");
          }
          if (svg.classList.contains("home-plans-avatar-circle--animated")) {
            svg.classList.remove("home-plans-avatar-circle--animated");
          }
        });
        setTimeout(() => {
          svgs[index].classList.add("home-plans-avatar-circle--animating");
          items[index].classList.add("home-plans-item--active");
          animationInterval = setInterval(
            () => animationIntervalFunction(),
            PICK_YOUR_PLAN_NUMBER_INTERVAL
          );
        }, 100);
      } else {
        svgs[index].classList.add("home-plans-avatar-circle--animated");
        // animate circle to end
      }
    })
  );
  }
};

const homeplanDesktopItems = Array.from(document.getElementsByClassName("home-plans-desktop-item"));

homeplanDesktopItems.forEach((element,index) => {
  element.getElementsByClassName("home-plans-button")[0].addEventListener('focus',()=>{
    element.classList.add("home-plans-desktop-item--hover");
    const contentItem = element.querySelector('.home-plans-desktop-item-content');
    
      if (contentItem) {
        contentItem.style.transform = `translateY(-${hoverHeights[index]}px)`;
      }
  });

  element.getElementsByClassName("home-plans-button")[0].addEventListener('blur',()=>{
    element.classList.remove("home-plans-desktop-item--hover");

    const contentItem = element.querySelector('.home-plans-desktop-item-content');
      if (contentItem) {
        contentItem.style.transform = 'translateY(0)';
      }
  });
  
  element.addEventListener("mouseenter", ()=> {
    element.classList.add("home-plans-desktop-item--hover");
  })

  element.addEventListener("mouseleave", ()=> {
    element.classList.remove("home-plans-desktop-item--hover");
  })
});

window.addEventListener('resize', () => {
  if (window.innerWidth >= 900) {
    clearInterval(animationInterval);
    desktopNumberReadyCallback();
  } else {
    if (!animationInterval) {
      numberReadyCallback();
    }
  }
});


const animatedNumber = new AnimatedNumber(null, numberReadyCallback);
const animatedNumbers = [new AnimatedNumber(null, desktopNumberReadyCallback), new AnimatedNumber(null, () => {}), new AnimatedNumber(null, () => {})];

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-gallery"] && !window.DesignMode) return;
  try {
      
const eyeButton = document.getElementsByClassName("eye-button")[0];
const gallerySection = document.getElementById("Pdp-gallery");
const lottiePlayer = document.querySelector(".lottie-player");
const cursor = document.querySelector(".cursor");
const galleryItem = Array.from(document.getElementsByClassName("pdp-gallery-image-wrapper"));
const galleryImage = Array.from(document.getElementsByClassName("pdp-gallery-image"));
const seeMoreText = document.querySelector(".seeMore-button-text");
const seeMoreButton = document.querySelector(".seeMore-button");

let paused = false;
let galleryOpened = false;

let counter = 0;
const animationSequence = [["blink","https://cdn.shopify.com/s/files/1/0649/3346/2232/t/4/assets/eye-blink-lottie.json"], ["look","https://cdn.shopify.com/s/files/1/0649/3346/2232/t/4/assets/eye-look-lottie.json"], ["roll","https://cdn.shopify.com/s/files/1/0649/3346/2232/t/4/assets/eye-roll-lottie.json"]];
let animationName = "blink";

let currentCursorTop;

if ( seeMoreButton ) {
  seeMoreText.innerHTML = `See ${galleryImage.length - 4} more`
}

const toggleGallery = (index) => {
  gallerySection.classList.toggle('gallery-opened');
  if (galleryOpened) {
    galleryOpened = false; 
  } else {
    galleryOpened = true;
  }
  
  gallerySection.scrollTo({
    top: galleryItem[index].offsetTop,
    left: 0,
    behavior: 'smooth'
  });
  
  const htmlElement = document.documentElement;
  
  if (!galleryOpened) {
    window.scrollTo(0,gallerySection.offsetTop)
    htmlElement.style.overflow = "auto";
    cursor.style.display = "block";

    if (seeMoreButton) {
      seeMoreButton.style.display = "flex";
    }
  } else {
    htmlElement.style.overflow = "hidden"; 
    cursor.style.display = "none";

    if (seeMoreButton) {
      seeMoreButton.style.display = "none";
    }
  }
}

lottie.loadAnimation({
    container: cursor, 
    renderer: "svg",
    loop: false,
    autoplay: false,
    path: "https://cdn.shopify.com/s/files/1/0649/3346/2232/t/4/assets/eye-blink-lottie.json",
    name: "blink"
});

const animateEye = () => {
  lottie.destroy(animationName);
    
  const selectAnimation = animationSequence[counter]; 

  let nextAnimationName = selectAnimation[0];
  let nextAnimationPath = selectAnimation[1];

  animationName = nextAnimationName;
  
  lottie.loadAnimation({
    container: cursor,
    renderer: "svg",
    loop: false,
    autoplay: true,
    path: nextAnimationPath,
    name: nextAnimationName,
  });
  
  // This takes care of lottie animation loop
  if (counter === 2) {
    counter = 0;
  } else {
    counter++;
  }
};

gallerySection.addEventListener("mouseenter", () => {
  if (window.innerWidth > 900) {
    cursor.style.display = galleryOpened ? "none" : "initial";
  }
});

gallerySection.addEventListener("mouseleave", () => {
  if (window.innerWidth > 900) {
    cursor.style.display = "none";
  }
})

gallerySection.addEventListener("mousemove", (e) => {
  const rect = gallerySection.getBoundingClientRect();
    cursor.style.left = e.clientX + "px";
    cursor.style.top = (e.clientY - rect.top) + "px";

    currentCursorTop = (e.clientY - rect.top);
      
    cursor.setAttribute("data-fromTop", (cursor.offsetTop - scrollY));
    cursor.setAttribute("data-fromSide", (cursor.offsetSide - scrollX));
});

window.addEventListener("scroll", () => {
    const fromTop = parseInt(cursor.getAttribute("data-fromTop"));
    cursor.style.top = scrollY + fromTop + "px";
    const OFFSET = 100;
    const rect = gallerySection.getBoundingClientRect();
    const elementBottom = rect.bottom;

    const shouldStick = window.innerHeight - elementBottom > 0;
    const shouldShow = rect.top < OFFSET;

    if(seeMoreButton) {
      seeMoreButton.style.position = shouldStick ? "absolute" : "fixed";
      seeMoreButton.style.opacity = shouldShow ? 1 : 0;            
    }
});

galleryItem.forEach(item => {
  item.addEventListener("mouseover", (e) => {
    animateEye();
  })
});

galleryImage.forEach((imageElement,index) => {
  imageElement.addEventListener("click", (e) => {
    if(window.innerWidth > 900) {
      toggleGallery(index);
    }
  });
});
let isSeeMore = false;
if(seeMoreButton) {
  const INITIAL_NUMBER_OF_IMAGES = 4;
  const eyeOpen = seeMoreButton.getElementsByTagName('svg')[0];
  const eyeClose = seeMoreButton.getElementsByTagName('svg')[1];

  eyeClose.style.display = "none";

  seeMoreButton.addEventListener("click", () => {
    if (isSeeMore) {
      isSeeMore = false;
    } else {
      isSeeMore = true;
    }

    if (isSeeMore) {
      galleryItem.forEach((imageElement) => {
        imageElement.style.display = "flex";
      });

      seeMoreText.innerHTML = "See less"; 
      eyeOpen.style.display = "none";
      eyeClose.style.display = "initial";
    } else {
      galleryItem.forEach((imageElement, index) => {
        if (index >= INITIAL_NUMBER_OF_IMAGES) {
          imageElement.style.display = "none";
        }
      });
      seeMoreText.innerHTML = `See ${galleryImage.length - 4} more`
      eyeOpen.style.display = "initial";
      eyeClose.style.display = "none";

      window.scrollTo({
        top: gallerySection.offsetTop,
        left: 0,
        behavior: 'smooth'
      });
    }
  });

  seeMoreButton.addEventListener("mouseenter", () => {
    cursor.style.opacity = "0";
  });

  seeMoreButton.addEventListener("mouseleave", () => {
    cursor.style.opacity = "1";
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-what-is-included"] && !window.DesignMode) return;
  try {
    

const allHotspots = Array.from(document.getElementsByClassName('whatIsIncluded-hotspot'));
const allTooltips = Array.from(document.getElementsByClassName('whatIsIncluded-hotspot-tooltip'));
const explainerSheet = document.getElementById("WhatIsIncluded-explainerSheet");
const explainerSheetInner = document.querySelector(".whatIsIncluded-explainerSheet-inner");
const eyeButton = explainerSheet.getElementsByTagName("svg")[0];
const htmlElement = document.documentElement;
let explainerSheetOpen = false;

const toggleMobileExplainerSheet = () => {
  explainerSheet.classList.toggle("explainerSheet-mobile-open");

  if (explainerSheetOpen) {
    explainerSheetOpen = false;
    allHotspots.forEach((hotspot) => {
      hotspot.classList.remove('hotspot--paused');
    });
    if ('bodyScrollLock' in window) {
      bodyScrollLock.enableBodyScroll(explainerSheet);
    }
  } else {
    explainerSheetOpen = true;
    allHotspots.forEach((hotspot) => {
      hotspot.classList.add('hotspot--paused');
    });
    if ('bodyScrollLock' in window) {
      bodyScrollLock.disableBodyScroll(explainerSheet);
    }
  }
}

eyeButton.addEventListener("click", () => {
  toggleMobileExplainerSheet();
  
});

const toggleTooltip = (hotspotIndex) => {
  allTooltips.forEach((tooltip, tooltipIndex) => {
    if (hotspotIndex === tooltipIndex) {
      // Empty explainerSheet container
      explainerSheetInner.childNodes.forEach(element => {
        if(element.tagName === "DIV") {
          element.remove();
        }
      });
      //Open ExplainerSheet
      toggleMobileExplainerSheet();
      //Clone and append tooltip
      const clone = tooltip.cloneNode(true);
      clone.style.left = "unset";
      clone.style.top = "unset";
      explainerSheetInner.appendChild(clone);
    }
  });
}

allHotspots.forEach((hotspot, index) => {
  hotspot.addEventListener("click", (e) => {
    if(window.innerWidth < 900) {
      toggleTooltip(index);
    }
  })
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !window.DesignMode) return;
  try {
    
  const buttons = Array.from(document.querySelectorAll('.press-controls-button'));
  const items = Array.from(document.querySelectorAll('.press-item'));
  const content = document.querySelector('.press-content');
  let activeIndex = 0;

  const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};


  const debouncedClick = debounce((index) => handleClick(index), 300);

  const handleClick = (index) => {
    activeIndex = index;
    const content = items[index];
    const button = buttons[index];
    const previouslyActiveButton = document.querySelector('.press-controls-button--active');
    const previouslyActiveContent = document.querySelector('.press-item--active');

    if (previouslyActiveButton && previouslyActiveContent) {
      previouslyActiveContent.classList.remove('press-item--active');
      previouslyActiveButton.classList.remove('press-controls-button--active');
    }

    button.classList.add('press-controls-button--active');

    setTimeout(() => {
      content.classList.add('press-item--active');
    }, 500);
  }

  if (buttons && items) {
    // Init
    handleClick(activeIndex);

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => handleClick(index));
    })

    let isOnLeftSide = true;
    const handleMouseMove = (event) => {
      if (window.innerWidth >= 900) {
        const containerWidth = event.target.offsetWidth;
      isOnLeftSide = containerWidth / event.offsetX > 2;

      if (isOnLeftSide) {
        content.classList.remove("press-content--right");
      } else {
        content.classList.add("press-content--right");
      }
      }
    };

    const handleArrowClick = () => {
      if (window.innerWidth >= 900) {
        const newIndex = isOnLeftSide ? activeIndex === 0 ? items.length - 1 : activeIndex - 1 : activeIndex === items.length -1 ? 0 : activeIndex + 1;
        debouncedClick(newIndex);
      }
    }

    content.addEventListener("mousemove", handleMouseMove);
    content.addEventListener("click", handleArrowClick);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["problem-module"] && !window.DesignMode) return;
  try {
    

const mobileHotspotsWrapper = document.getElementsByClassName('problem-content-wrapper-inner')[0];
const desktopHotspotsWrapper = document.getElementsByClassName('problem-content-desktop')[0];

const mobileHotspots = Array.from(mobileHotspotsWrapper.getElementsByClassName('problem-hotspot'));
const desktopHotspots = Array.from(desktopHotspotsWrapper.getElementsByClassName('problem-hotspot'));

const allTooltips = Array.from(document.getElementsByClassName('problem-hotspot-tooltip'));
const explainerSheet = document.getElementById("problem-explainerSheet");
const explainerSheetInner = document.querySelector(".problem-explainerSheet-inner");
const eyeButton = explainerSheet.getElementsByTagName("svg")[0];

const htmlElement = document.documentElement;
let explainerSheetOpen = false;

const toggleMobileExplainerSheet = () => {
  explainerSheet.classList.toggle("explainerSheet-mobile-open");

  if (explainerSheetOpen) {
    explainerSheetOpen = false;
    mobileHotspots.forEach((hotspot) => {
      hotspot.classList.remove('hotspot--paused');
    });
    if ('bodyScrollLock' in window) {
      bodyScrollLock.enableBodyScroll(explainerSheet);
    }
  } else {
    explainerSheetOpen = true;
    mobileHotspots.forEach((hotspot) => {
      hotspot.classList.add('hotspot--paused');
    });
    if ('bodyScrollLock' in window) {
      bodyScrollLock.disableBodyScroll(explainerSheet);
    }
  }
}

eyeButton.addEventListener("click", () => {
  toggleMobileExplainerSheet();
});

const toggleTooltip = (hotspotIndex) => {
  allTooltips.forEach((tooltip, tooltipIndex) => {
    if (hotspotIndex === tooltipIndex) {
      // Empty explainerSheet container
      explainerSheetInner.childNodes.forEach(element => {
        if(element.tagName === "DIV") {
          element.remove();
        }
      });
      //Open ExplainerSheet
      toggleMobileExplainerSheet();
      //Clone and append tooltip
      const clone = tooltip.cloneNode(true);
      clone.style.left = "unset";
      clone.style.top = "unset";
      explainerSheetInner.appendChild(clone);
    }
  });
}

const bacteriaImagesWrapper = document.getElementsByClassName("problem-bacterias-desktop")[0]
const bacteriaImages = Array.from(bacteriaImagesWrapper.getElementsByClassName("bacteria-path")).reverse();

if (window.innerWidth > 900) {
  desktopHotspots.forEach((hotspot, index) => {

    const openEvents = ['mouseenter','focus'];
    const closeEvents = ['mouseleave','blur'];

    closeEvents.forEach(eventType => {
      hotspot.addEventListener(eventType, (e) => {
        bacteriaImages[index].classList.remove("fillBlack");
        hotspot.classList.remove("problem-hotspot--hover");
      })
    });

    openEvents.forEach(eventType => {
      hotspot.addEventListener(eventType, (e) => {
        bacteriaImages[index].classList.add("fillBlack");
        hotspot.classList.add("problem-hotspot--hover");
      })
    });
  });

} else if (window.innerWidth > 600) {
  desktopHotspots.forEach((hotspot, index) => {
    hotspot.addEventListener("click", (e) => {
      toggleTooltip(index);
    })
  });
} else {
  mobileHotspots.forEach((hotspot, index) => {
    hotspot.addEventListener("click", (e) => {
      toggleTooltip(index);
    })
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research"] && !window.DesignMode) return;
  try {
    
const resesarchSwiper = new Swiper('.swiper-research', {
  loop: true,
  pagination: {
    el: '.swiper-custom-pagination',
    clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + ' swiper-research-dots"></span>';
      },
  },
});

const pieSvg = document.querySelector('.research-svg');
const pieCircle1 = pieSvg.querySelector('.pie1');
const pieBorder = pieSvg.querySelector('.pie-border');
const piePercentage = this.piePercentage;
const rest = 100 - Number(piePercentage);

function handleScroll() {
  const rect = pieSvg.getBoundingClientRect();
  // Animate PieChart once it is in view

  if (rect.top >= 0 && rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
      pieCircle1.style.strokeDasharray = `0, 0, ${piePercentage}, ${rest}`;
      pieBorder.style.strokeDashoffset = '0';
      document.removeEventListener('scroll', handleScroll);
    }
}

document.addEventListener('scroll', handleScroll);

const bacteriaContainer = document.getElementsByClassName("research-carousel")[0];

let isOnLeftSide = true;
const handleMouseMove = (event) => {
  const containerWidth = event.target.offsetWidth;
  isOnLeftSide = containerWidth / event.offsetX > 2;
  
  if (isOnLeftSide) {
    bacteriaContainer.classList.remove("research-carousel--right");
    bacteriaContainer.classList.add("research-carousel--left");
  } else {
    bacteriaContainer.classList.remove("research-carousel--left");
    bacteriaContainer.classList.add("research-carousel--right");
  }
};

const handleClick = () => {
  if (isOnLeftSide) {
    resesarchSwiper.slidePrev(300);
  } else {
    resesarchSwiper.slideNext(300);
  }
};

if (window.innerWidth >= 600) {
  bacteriaContainer.addEventListener("mousemove", handleMouseMove);
  bacteriaContainer.addEventListener("click", handleClick);
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsible-replenishment"] && !window.DesignMode) return;
  try {
    

let accordionRR;

function setDesktopAccordionDimensions () {
    const desktopMediaContent = Array.from(document.getElementsByClassName('responsible-replenishment-desktop-image'));
    const desktopMediaContainerElement = document.getElementsByClassName("responsible-replenishment-desktop")[0];
    const desktopMediaContainerElementHeight = desktopMediaContainerElement.getBoundingClientRect().height;

    desktopMediaContent.forEach(element => {
        element.setAttribute('style',`top: ${0.55 * desktopMediaContainerElementHeight}px; height: ${1.5 * desktopMediaContainerElementHeight}px`);
    });
}

window.addEventListener("DOMContentLoaded", (event) => {
    const accordionParent = document.querySelector(".responsible-replenishment-accordion");
    const accordionTitle = Array.from(document.getElementsByClassName("responsible-replenishment-accordion-heading"));
    const accordionContent = Array.from(document.getElementsByClassName("responsible-replenishment-accordion-content"));
    
    const accordionClass = customElements.get("accordion-component");
    if (accordionClass) {
        accordionRR = new accordionClass();
    }

    accordionRR.renderAccordion(accordionParent,accordionTitle,accordionContent);
        
    const titleArray =  Array.from(document.getElementsByClassName("responsible-replenishment-desktop-row"));
    
    titleArray.forEach(element => {
        const content = element.getElementsByClassName("responsible-replenishment-desktop-row-description")[0];
        const title = element.getElementsByClassName("responsible-replenishment-desktop-row-title")[0];

        element.dataset.closedHeight = element.clientHeight - content.clientHeight;
        element.dataset.openedHeight = element.clientHeight;

        element.style.height =`${element.clientHeight - content.clientHeight}px`;

        element.addEventListener('mouseenter', ()=> {
            element.style.height = `${element.dataset.openedHeight}px`;
        })
        element.addEventListener('mouseleave', ()=> {
            element.style.height = `${element.dataset.closedHeight}px`;
        })
    });
    
    
    setTimeout(() => {
        const sectionWrapper = document.getElementsByClassName("responsible-replenishment")[0];
        setDesktopAccordionDimensions();
        
        if (window.matchMedia('(min-width: 900px)').matches) {	
            sectionWrapper.style.height = `${sectionWrapper.clientHeight + 160}px`;
        } else {
            sectionWrapper.style.height = 'auto';
        }
    }, 100);

    window.addEventListener('resize', () => {
        setDesktopAccordionDimensions();
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !window.DesignMode) return;
  try {
    
let activeIndex = 0;
const container = document.querySelector(".reviews-carousel-swiper");
const swiper = new Swiper(container, {
  loop: true,
  spaceBetween: 4,
  slidesPerView: 1.25,
  centeredSlides: true,
  slideActiveClass: "reviews-carousel--active",
  breakpoints: {
    320: {
      slidesPerView: 1.25,
    },
    600: {
      slidesPerView: 3.25,
    },
    900: {
      slidesPerView: 4.25,
    },
    1440: {
      slidesPerView: 5.25,
    },
    1600: {
      slidesPerView: 6.25,
    }
  },
});

let COLORS = {
  0: "#31CA9F",
  1: "#FF8B50",
  2: "#87CAD7",
  3: "#F5B3D0",
  4: "#EFF0E8",
};

const allSwiperSlides = Array.from(
  document.querySelectorAll(".review-carousel-item")
);


const getColorBasedOnIndex = (index) => {
  // 5:0 - 6:1 - 7:2 - 8:3 etc...
  let colorIndex;
  if (index <= 4) {
    colorIndex = index;
  } else {
    const numberOfColors = Object.keys(COLORS).length;
    colorIndex = Math.round(((index / numberOfColors) % 1) * numberOfColors);
  }  
  return colorIndex;
}

allSwiperSlides.forEach((slide, index) => {
  if (window.innerWidth < 600) {
    if (slide.parentElement && slide.parentElement.classList.contains('reviews-carousel--active')) {
      slide.style.backgroundColor = COLORS[getColorBasedOnIndex(swiper.realIndex)];
    }
  }
  slide.addEventListener("mouseover", () => {
    if (window.innerWidth >= 600) {
      slide.style.backgroundColor = COLORS[getColorBasedOnIndex(index)];
    }
  });

  slide.addEventListener("mouseleave", () => {
    if (window.innerWidth >= 600) {
      slide.style.backgroundColor = "transparent";
    }
  });
});

const prevButton = document.querySelector('.reviews-carousel-button-left');
const nextButton = document.querySelector('.reviews-carousel-button-right');

prevButton.addEventListener('click', () => {
  swiper.slidePrev(300);
})

nextButton.addEventListener('click', () => {
  swiper.slideNext(300);
})

const handleBackgroundUpdate = (activeIndex) => {
  const allSlides = Array.from(
    document.querySelectorAll(".swiper-slide")
  );
  allSlides.forEach((slide, index) => {
    slide.firstElementChild.style.backgroundColor = slide.classList.contains(
      "reviews-carousel--active"
    )
      ? COLORS[getColorBasedOnIndex(activeIndex)]
      : "transparent";
  });
};

swiper.on("slidePrevTransitionStart", function (swiperInstance) {
  activeIndex = activeIndex - 1;
  handleBackgroundUpdate(activeIndex);
});

swiper.on("slideNextTransitionStart", function (swiperInstance) {
  activeIndex = activeIndex + 1;
  handleBackgroundUpdate(activeIndex);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !window.DesignMode) return;
  try {
    

const containers = Array.from(document.querySelectorAll('.specifications'));
const accordionClass = customElements.get("accordion-component");

containers.forEach((container) => {
  const accordion = new accordionClass();

  const swiperSlides = Array.from(container.querySelectorAll('.swiper-slide'));
  const title = container.querySelector('.specifications-title');
  const content = container.querySelector('.specifications-content');

  if (swiperSlides.length) {

    const mainContainer = document.createElement('div');
    mainContainer.classList.add('specifications-main-container');
    const desktopContainer = document.createElement('div');
    desktopContainer.classList.add('specifications-slider-desktop');
    const swiperContainer = document.createElement('div');
    swiperContainer.classList.add('swiper');
    const swiperWrapper = document.createElement('div');
    swiperWrapper.classList.add('swiper-wrapper');
    
    const swiperPaginationIndicatorsElement = document.createElement('div');
    swiperPaginationIndicatorsElement.classList.add('swiper-custom-pagination', 'specifications-dots-wrapper');
    
    
    swiperContainer.appendChild(swiperWrapper);
    swiperContainer.appendChild(swiperPaginationIndicatorsElement);
    mainContainer.appendChild(desktopContainer);
    mainContainer.appendChild(swiperContainer);
    container.appendChild(mainContainer);

    swiperSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      desktopContainer.appendChild(clone);
      swiperWrapper.appendChild(slide);
    });

    const swiper = new Swiper(swiperContainer, {
      loop: true,
      pagination: {
        el: swiperPaginationIndicatorsElement,
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + ' specifications-dot"></span>';
          },
      },
    });
    
    const allParapraphs = container.querySelectorAll('.specifications-richtext p');

    if(allParapraphs.length) {
      const paragraphWrapper = document.createElement('div');
      paragraphWrapper.classList.add('specifications-richtext', 'with-padding');
      
      mainContainer.appendChild(paragraphWrapper);
      allParapraphs.forEach((paragraph) => {
        paragraph.classList.add('typography', 'body')
        paragraphWrapper.appendChild(paragraph)
      })
      
      mainContainer.appendChild(paragraphWrapper);
    } 

    accordion.renderAccordion(container, [title], [mainContainer], false);
    
  } else {
    const allParapraphs = container.querySelectorAll('.specifications-richtext p');
    allParapraphs.forEach((paragraph) => paragraph.classList.add('typography', 'body'));
    accordion.renderAccordion(container, [title], [content], false);
  }
  
  container.classList.add('specifications-ready');
});

containers.forEach(container => {
  const allRichTextElements = container.querySelectorAll('.specifications-richtext');
  allRichTextElements.forEach(element => {
    const containsOnlyWhitespaces = element.innerHTML.trim().length ===0;

    if (containsOnlyWhitespaces) {
      element.remove();
    }
  });
});


  } catch(e) { console.error(e); }
})();

})();
